module.exports = __webpack_public_path__ + "img/i-info.8a126c37.svg";